import { connect } from 'react-redux'

import PropiedadView from '../../../components/Sections/Propiedades/PropiedadesList/propiedad'
import { setPanelProfile } from '../../../actions/header'
import { loadProperty, loadRelatedProperties } from '../../../actions/propiedades'

const mapStateToProps = (state) => {
  return {
    originPath: state.searchBar.originPath,
    categories: state.office.categories,
    phone: state.header.telephone,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChangePanelProfile: () => dispatch(setPanelProfile()),
    loadPropertyDetails: value => {
      dispatch(loadProperty(value))
      dispatch(loadRelatedProperties(value))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropiedadView)



// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/propiedad.js